import type { DealParticipant } from '@openx/types/deal';
import type { Option, OptionsMap } from '@openx/types/options';

/** OptionsByPath keeps enrichment on the raw `extra` payload, which is flattened onto the option. */
type PartnerEnrichment = Pick<Option, 'enrichment_features'> & {
  extra?: Pick<Option, 'enrichment_features'>;
};

export const isRetargetingCapablePartner = (partner: PartnerEnrichment | undefined): boolean =>
  partner?.enrichment_features?.retargeting === true || partner?.extra?.enrichment_features?.retargeting === true;

/**
 * True when at least one selected deal participant's demand partner has
 * enrichment_features.retargeting.
 */
export const hasRetargetingCapableDsp = (
  dealParticipants: DealParticipant[] | null | undefined,
  mapById: OptionsMap
): boolean => {
  if (!Array.isArray(dealParticipants)) {
    return false;
  }

  return dealParticipants.some(participant => {
    const demandPartner = participant?.demand_partner;

    return !!demandPartner && isRetargetingCapablePartner(mapById[demandPartner]);
  });
};
